import React, { useState } from 'react';
import { useSubscription } from '../contexts/SubscriptionContext';
import { useNavigate } from 'react-router-dom';
import { Calendar, Crown, X, AlertTriangle } from 'lucide-react';

const SubscriptionBanner = () => {
  const { isTrialActive, isSubscriptionActive, getDaysLeftInTrial, isSpecialAccount } = useSubscription();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(true);

  const daysLeft = getDaysLeftInTrial();

  // Don't show banner if user has active subscription, is special account, or no trial
  if (!isTrialActive() || !isVisible || isSpecialAccount()) {
    return null;
  }

  // Show banner when trial has 3 days or less remaining
  if (daysLeft > 3) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-3 relative z-40">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          {daysLeft === 0 ? (
            <AlertTriangle className="w-5 h-5 text-yellow-300" />
          ) : (
            <Calendar className="w-5 h-5" />
          )}
          <div>
            <p className="font-medium">
              {daysLeft === 0 
                ? "Your free trial has expired!" 
                : `Your free trial ends in ${daysLeft} day${daysLeft === 1 ? '' : 's'}`
              }
            </p>
            <p className="text-sm opacity-90">
              Upgrade to continue using all DeckLink features
            </p>
          </div>
        </div>
        
        <div className="flex items-center space-x-3">
          <button
            onClick={() => navigate('/subscription')}
            className="bg-white text-blue-600 px-4 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors flex items-center space-x-2"
          >
            <Crown className="w-4 h-4" />
            <span>Upgrade Now</span>
          </button>
          
          <button
            onClick={() => setIsVisible(false)}
            className="text-white hover:text-gray-200 transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionBanner; 